export enum BaseInquiryClosingReasons {
  default = '',
  notNeeded = 'notNeeded',
  solvedInternally = 'solvedInternally',
  noApproval = 'noApproval',
  other = 'other',
}
